import { getRouteApi } from '@tanstack/react-router';

const dealsRouteApi = getRouteApi('/_authed/deals/');

export function useDealsRouteSearch() {
  return dealsRouteApi.useSearch();
}
